// extracted by mini-css-extract-plugin
export default {"Container":"ReportedBusiness_Container__X8awV","TabContainer":"ReportedBusiness_TabContainer__VQnSR","Posts":"ReportedBusiness_Posts__a4YSi"};